import AttToken from "../../../helpers/attToken";
import { useEffect, useState } from "react";
import Users from "../../../service/Users";
import { userBackObj } from "../../Users/UserSearch";
import { useTranslation } from "react-i18next";
import Tickets from "../../../service/Tickets";
import { toast } from "react-toastify";
import { trackEventMatomo } from "../../../helpers/matomo";
import QueryFn from "../../../helpers/QueryFn";
import HeaderModal from "../../HeaderModal/HeaderModal";
import FooterModal from "../../FooterModal/FooterModal";
import { Skeleton, TextField } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

type props = {
  openRedirect: boolean,
  setOpenRedirect: Function,
  chamadoId: string
};

const usersService = new Users();
const ticketsService = new Tickets();
const queryFn = new QueryFn();

export default function RedirectModal({
  openRedirect,
  setOpenRedirect,
  chamadoId

}: props) {
  const { t } = useTranslation('translation');
  const [encaminhadoPara, setEncaminhadoPara] = useState<string>('');
  const [motivoEncaminhamento, setMotivoEncaminhamento] = useState<string>('');

  const { data, isLoading, } = queryFn.useFetch('GET_USERS',
    async () => {
      try {
        const token = await AttToken();
        if (token) {
          const body = { ...token };
          const result = await usersService.getAllUsers(body);
          return result.users;
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },
  );

  const { mutate } = queryFn.useMutate('REDIRECT_TICKET',
    async () => {
      try {
        const token = await AttToken();
        if (token) {
          toast.warn(`${t('notifications.modals.redirectingTicket')}`);
          await ticketsService.redirecionaChamado(token, chamadoId, motivoEncaminhamento, encaminhadoPara, 'redireciona');
          toast.success(`${t('notifications.modals.ticketRedirected')}`);
          setOpenRedirect();
        } else {
          setOpenRedirect();
          toast.error(`${t('notifications.modals.errorRedirecting')}`);
        }
      } catch (error) {
        console.error("Error mutating redirect ticket:", error);
      }
    });

  const close = () => {
    trackEventMatomo('modal redireciona chamado', 'click', 'button', 'cancela');
    setOpenRedirect();
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  const submit = () => {
    trackEventMatomo('modal redireciona chamado', 'click', 'button', 'redireciona');
    mutate('');
  };

  return (
    <div className={`modal ${openRedirect ? "modal is-active" : "modal"}`}>
      <div className="modal-background" onClick={close} onKeyDown={(e) => escape(e)} />
      <div className="modal-card" style={{ height: '450px' }}>
        <HeaderModal headerTitle={t('notifications.modals.redirectTicket')} close={close} />
        <div className="modal-card-body">
          {isLoading ? <Skeleton variant="rounded" height={40} width='100%' /> :
            <>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{t('notifications.modals.selectUser')}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={t('notifications.modals.selectUser')}
                  onClick={() => trackEventMatomo('modal redireciona chamado', 'click', 'select', 'selciona valor')}
                  onChange={(e: any) => {
                    setEncaminhadoPara(e.target.value);
                  }}
                >
                  <MenuItem value='' >{t('select')}</MenuItem>
                  {data.sort((a: userBackObj, b: userBackObj) => { return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1; })
                    .filter((e: userBackObj) => e.status === 'ativo')
                    .map((e: userBackObj, i: number) => (
                      <MenuItem value={e.email} key={i}>{e.nome}</MenuItem>
                    ))}
                </Select>
              </FormControl>
              <TextField
                sx={{ marginTop: '20px' }}
                fullWidth
                multiline
                rows={3}
                label={t('notifications.modals.writeReasonForRedirecting')}
                onClick={() => trackEventMatomo('modal redireciona chamado', 'click', 'textarea', 'edita valor')}
                className="textarea"
                value={motivoEncaminhamento}
                onChange={(e) => setMotivoEncaminhamento(e.target.value)}
                style={{ resize: 'none' }}
              />
            </>}
        </div>
        <FooterModal submit={submit} label={t('notifications.modals.redirect')} disabled={false} />
      </div>
    </ div >
  );
}
